// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oCEce3rpP1HPJpEkGfss {
  flex: none;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: 600;
  background-color: var(--dk-grey-color);
  border: solid 2px var(--dk-grey-color);
  border-radius: 0.25em;
  text-decoration: none !important;
  transition: var(--global-nav-transition);
}

.n4iIvQa7eTxjsHFpM1HT {
  font-size: var(--step--3);
  padding: var(--space-3xs) var(--space-xs);
  height: 2.1rem;
  width: max-content;
}

.xq00q9cn86hVg2bvXXrz {
  font-size: var(--step--1);
  padding: var(--space-2xs) var(--space-2xs);
  margin: 0.5rem;
  max-height: 2rem;
}

.KJ6qAhnXlUP6Djv6a9Qh {
  font-size: var(--step--2);
  padding: var(--space-2xs) var(--space-2xs);
  margin: 0.3rem;
  max-height: 1rem;
}

.n4iIvQa7eTxjsHFpM1HT:hover,
.n4iIvQa7eTxjsHFpM1HT:focus,
.xq00q9cn86hVg2bvXXrz:hover,
.xq00q9cn86hVg2bvXXrz:focus,
.KJ6qAhnXlUP6Djv6a9Qh:hover,
.KJ6qAhnXlUP6Djv6a9Qh:focus {
  background-color: rgba(34, 46, 52, 0.8);
  border: solid 2px rgba(34, 46, 52, 0.8);
}

.n4iIvQa7eTxjsHFpM1HT:active,
.xq00q9cn86hVg2bvXXrz:active,
.KJ6qAhnXlUP6Djv6a9Qh:active {
  background-color: rgba(34, 46, 52, 0.5);
  border: solid 2px rgba(34, 46, 52, 0.5);
}

.YfzvyTrG5RXeGwyQsdev {
  color: var(--secondary-alt-color);
  text-transform: capitalize;
}

.sMldumnzy4dQRk4GeEJP {
  color: var(--place-color);
}

.FK11oVA1uKVatc51YQXI {
  color: var(--topic-color);
}

.zkXcR5nY1a_xWxDwZl7D {
  color: var(--keyword-color);
}

/* Skeleton loading animation */
@keyframes dudSgAFBj35DPSYGdOHv {
  0% {
    opacity: 0.6;
  }
  70% {
    opacity: 0.8;
  }
  100% {
    opacity: 0.6;
  }
}

.dudSgAFBj35DPSYGdOHv {
  background: var(--dk-grey-color);
  color: transparent !important;
  pointer-events: none;
  animation: dudSgAFBj35DPSYGdOHv 0.8s ease-in-out infinite;
}
`, "",{"version":3,"sources":["webpack://./src/widgets/buttons/PillLink.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,sCAAsC;EACtC,qBAAqB;EACrB,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;;EAME,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;;;EAGE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,oBAAoB;EACpB,yDAAkD;AACpD","sourcesContent":[".pillLinkBase {\n  flex: none;\n  display: inline-flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-weight: 600;\n  background-color: var(--dk-grey-color);\n  border: solid 2px var(--dk-grey-color);\n  border-radius: 0.25em;\n  text-decoration: none !important;\n  transition: var(--global-nav-transition);\n}\n\n.pillLink {\n  font-size: var(--step--3);\n  padding: var(--space-3xs) var(--space-xs);\n  height: 2.1rem;\n  width: max-content;\n}\n\n.pillLinkSmaller {\n  font-size: var(--step--1);\n  padding: var(--space-2xs) var(--space-2xs);\n  margin: 0.5rem;\n  max-height: 2rem;\n}\n\n.pillLinkExtraSmall {\n  font-size: var(--step--2);\n  padding: var(--space-2xs) var(--space-2xs);\n  margin: 0.3rem;\n  max-height: 1rem;\n}\n\n.pillLink:hover,\n.pillLink:focus,\n.pillLinkSmaller:hover,\n.pillLinkSmaller:focus,\n.pillLinkExtraSmall:hover,\n.pillLinkExtraSmall:focus {\n  background-color: rgba(34, 46, 52, 0.8);\n  border: solid 2px rgba(34, 46, 52, 0.8);\n}\n\n.pillLink:active,\n.pillLinkSmaller:active,\n.pillLinkExtraSmall:active {\n  background-color: rgba(34, 46, 52, 0.5);\n  border: solid 2px rgba(34, 46, 52, 0.5);\n}\n\n.pillLinkText {\n  color: var(--secondary-alt-color);\n  text-transform: capitalize;\n}\n\n.location {\n  color: var(--place-color);\n}\n\n.topic {\n  color: var(--topic-color);\n}\n\n.keywords {\n  color: var(--keyword-color);\n}\n\n/* Skeleton loading animation */\n@keyframes skeletonPulse {\n  0% {\n    opacity: 0.6;\n  }\n  70% {\n    opacity: 0.8;\n  }\n  100% {\n    opacity: 0.6;\n  }\n}\n\n.skeletonPulse {\n  background: var(--dk-grey-color);\n  color: transparent !important;\n  pointer-events: none;\n  animation: skeletonPulse 0.8s ease-in-out infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pillLinkBase": `oCEce3rpP1HPJpEkGfss`,
	"pillLink": `n4iIvQa7eTxjsHFpM1HT`,
	"pillLinkSmaller": `xq00q9cn86hVg2bvXXrz`,
	"pillLinkExtraSmall": `KJ6qAhnXlUP6Djv6a9Qh`,
	"pillLinkText": `YfzvyTrG5RXeGwyQsdev`,
	"location": `sMldumnzy4dQRk4GeEJP`,
	"topic": `FK11oVA1uKVatc51YQXI`,
	"keywords": `zkXcR5nY1a_xWxDwZl7D`,
	"skeletonPulse": `dudSgAFBj35DPSYGdOHv`
};
export default ___CSS_LOADER_EXPORT___;
